export default __webpack_public_path__ + "static/media/news-1.be50ff0f.jpg";